import React, { useState } from 'react';
import { Card, Collapse } from 'react-bootstrap';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const ModuleWrapper = ({ module, children, startIndex }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  // Calculate total marks from questions in module
  const totalMarks = module.question_set?.reduce((sum, q) => sum + (parseFloat(q.marks) || 0), 0) || 0;

  return (
    <div className="module-wrapper" style={{ marginBottom: '20px' }}>
      <Card style={{ border: '2px solid rgb(41, 121, 255)', borderRadius: '5px' }}>
        <Card.Header
          style={{
            backgroundColor: '#f8f9fa',
            padding: '10px 15px'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ flex: 1 }}>
              <h5 style={{ margin: 0, color: 'rgb(41, 121, 255)', fontWeight: 'bold' }}>
                {module.name}
              </h5>
            </div>
            <div style={{ fontStyle: 'italic', fontWeight: 'bold', color: 'rgb(41, 121, 255)' }}>
              Total Marks: {totalMarks.toFixed(2)}
            </div>
          </div>

          {module.description && (
            <div
              style={{
                marginTop: '10px',
                paddingTop: '10px',
                borderTop: '1px solid #dee2e6',
                fontSize: '14px',
                color: '#495057'
              }}
            >
              {parse(DOMPurify.sanitize(module.description))}
            </div>
          )}
        </Card.Header>

        <Collapse in={isExpanded}>
          <div>
            <Card.Body style={{ padding: '15px', backgroundColor: '#fff' }}>
              {children}
            </Card.Body>
          </div>
        </Collapse>
      </Card>
    </div>
  );
};

export default ModuleWrapper;
